export const HEX_PATH_ATLAS_ROTATION_STEPS = 0;

export function getPathTileRenderRotationOffset(gridType: string): number {
  return gridType === 'hex' ? HEX_PATH_ATLAS_ROTATION_STEPS : 0;
}

export function combinePathTileRotationSteps(baseSteps: number, offsetSteps: number): number {
  return ((((baseSteps % 12) + 12) % 12) + (((offsetSteps % 12) + 12) % 12)) % 12;
}
